import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-promocode-chat',
  templateUrl: './promocode-chat.component.html',
  styleUrls: ['./promocode-chat.component.css']
})
export class PromocodeChatComponent implements OnInit {

  payAmount = 0;
  public onClose: Subject<{}>;
  allPromoCodes = [];

  promoCode = '';

  constructor(
    private auth: AuthService,
    public _bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.onClose = new Subject();
  }

  getPromo() {
    let obj = {
      total_price: this.payAmount * 20
    }
    this.auth.getData('/PromoCodes/user_list_promo_codes', obj).subscribe(res => {
      this.allPromoCodes = res['data'];
    }, error => {

    })
  }

  applyCode() {
    if(this.promoCode.trim()) {
      this.applyPromoCode(this.promoCode);
    }
  }

  applyPromoCode(name) {
    let obj = {
      total_price: this.payAmount * 20,
      booking_type: 'CHAT',
      promotion_name: name
    }
    this.auth.postData('/PromoCodes/user_apply_promo_codes', obj).subscribe(res => {
      this.onClose.next(res['data'].booking_amount);
      this._bsModalRef.hide();
    }, error => {
    })
  }

}
